/**
 * Currency configuration mapping for different locales/countries
 * 
 * Slovenia (sl): EUR - Eurozone country
 * Romania (ro): RON - Romanian Leu
 * Bulgaria (bg): BGN - Bulgarian Lev
 * English (en): EUR - fallback to Euro
 */
export const currencyConfig = {
  sl: { symbol: '€', code: 'EUR', locale: 'sl-SI', position: 'after' },
  ro: { symbol: 'lei', code: 'RON', locale: 'ro-RO', position: 'after' },
  bg: { symbol: '€.', code: 'EUR', locale: 'bg-BG', position: 'after' },
  en: { symbol: '€', code: 'EUR', locale: 'en-GB', position: 'after' },
};

/**
 * Get currency configuration for a given language
 * @param {string} language - Language code (sl, ro, bg, en)
 * @returns {Object} Currency configuration object
 */
export const getCurrencyConfig = (language) => {
  return currencyConfig[language] || currencyConfig.en;
};

export default currencyConfig;

